import { Deserializable } from '../../deserializable';
import { NamedEntityDto } from '../named-entity-dto';
import { ArtefactActivityDto } from './artefact-activity-dto.model';
import { BaseApplicationCaseDetailsDto } from './base-application-case-details-dto.model';

export class ArtefactDetailsDto extends BaseApplicationCaseDetailsDto implements Deserializable {
  public SubmissionDate?: Date;
  public SubmittedBy: string;
  public ModifiedBy: string;
  public SamID: string;
  public CompanyName: string;
  public Scoreband: string;
  public LastModifiedDate?: Date;
  public CaseOwner: string;
  public CaseOwnerID?: number;
  public CaseOwnerIDHash: string;
  public TeamCode: string;
  public AdviceOwner: string;
  public AdviceOwnerID?: number;
  public AdviceOwnerIDHash: string;
  public AdviceTeamCode: string;
  public CaseAdministratorsNames: Array<NamedEntityDto>;
  public OriginatorId: string;
  public OriginatorName: string;
  public OriginatorDetails: string;
  public OriginatorUserName: string;
  public OriginatorCompanyDetails: string;
  public AmlManualCheckLink: string;
  public IsExternalSubmission?: number;
  public FeeAmount: number;
  public TransactionStatus: string;
  public RepaymentTypeCode: string;
  public PropertyAddress: string;
  public WasAssessmentReleased?: boolean;
  public LastRomeStatusCode: string;
  public CanUploadDocuments: boolean;
  public HasUploadedDocuments: boolean;
  public CompanyFsaNumber?: number;
  public CompanyPrincipalFsaNumber?: number;
  public DecisionTypeCode: string;
  public SubmittedById: string;
  public ModifiedById: string;
  public DecisionsAndStatuses: Array<ArtefactActivityDto>;
  public PropositionLogoPath: string;
  public IsAipCertificateAvailable?: boolean;
  public IsPdfBundleAvailable?: boolean;
  public ReasonForDocumentUploadNotAvaialable: string;
  public Branch: string;
  public InterfaceTypeId: number;
  public ReleasedFromAdvised?: boolean;
  public IsKfiAccepted: boolean;
  public BranchUserId: string;
  public IsNonAdvisedArtefactInAdvisedCase: boolean;
  public IsSelfBuildPropertyType: boolean;
  public ArePackagePlaceholdersFullfilled: boolean;

  public IsDataCompleted?: boolean;
  public SuitabilityReportID?: number;
  public SuitabilityReportIDHash: string;
  public IsDownloadedToSAM: boolean;
  public PropositionId: number;
  public SubmittedDate?: Date;

  public CanViewAip: boolean;
  public CanViewApp: boolean;
  public ReactivateSwitchCaseAllowed: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    this.CaseAdministratorsNames =
      input !== null && input.CaseAdministratorsNames !== null
        ? input.CaseAdministratorsNames.map((namedEntityDto: NamedEntityDto) =>
            new NamedEntityDto().deserialize(namedEntityDto)
          )
        : undefined;

    this.DecisionsAndStatuses =
      input !== null && input.DecisionsAndStatuses !== null
        ? input.DecisionsAndStatuses.map((artefactActivityDto: ArtefactActivityDto) =>
            new ArtefactActivityDto().deserialize(artefactActivityDto)
          )
        : undefined;

    this.CaseAdministratorsNames =
      input !== null && input.CaseAdministratorsNames !== null
        ? input.CaseAdministratorNames.map((namedEntityDto: NamedEntityDto) =>
            new NamedEntityDto().deserialize(namedEntityDto)
          )
        : undefined;

    return this;
  }
}
